function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#27AE60",
  fillRule: "evenodd",
  d: "M15.117 67.883C.27 53.036.27 28.964 15.117 14.117 29.964-.73 54.035-.73 68.882 14.117c14.847 14.847 14.847 38.919 0 53.766-14.847 14.847-38.918 14.847-53.765 0zm-2.122-55.887c-16.018 16.018-16.018 41.99 0 58.008 16.019 16.019 41.99 16.019 58.009 0 16.018-16.018 16.018-41.99 0-58.008-16.019-16.019-41.99-16.019-58.009 0zm12.037 29.433l11.586 10.073 22.637-22.638 2.121 2.121L37.75 54.612l-.99.99-1.055-.918-12.64-10.991 1.967-2.264z",
  clipRule: "evenodd"
});

function SvgOk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 83,
    fill: "none"
  }, props), _ref);
}

export default __webpack_public_path__ + "a474da36f1c66464edb263b2e56049db.svg";
export { SvgOk as ReactComponent };